// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TokenIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TokenIcon" ref={forwardedRef} {...props}>
      <path d="M10.405 7.194a3.01 3.01 0 0 0 2.217 2.38l1.628.413-1.628.413a3.01 3.01 0 0 0-2.217 2.38L10 15.01l-.404-2.23a3.01 3.01 0 0 0-2.217-2.38L5.75 9.987l1.628-.413a3.01 3.01 0 0 0 2.217-2.38L10 4.965z" />
      <path d="M9.346 1.387a1 1 0 0 1 .992-.01l6.9 3.876A1 1 0 0 1 17.75 6.13v7.74c0 .364-.196.7-.512.877l-6.9 3.876a1 1 0 0 1-.992-.01l-6.6-3.873a1 1 0 0 1-.496-.867V6.127A1 1 0 0 1 2.745 5.26zM5.183 5.574H5.18L3.754 6.403v.895L3.75 7.295v6.29l4.744 2.784.002.003.462.27.139.08.79.462 2.789-1.601 3.574-2.007v-7.17l-1.548-.851-4.847-2.723z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TokenIcon = /* @__PURE__ */ Object.assign(TokenIconComponent, {
  displayName: 'TokenIcon',
});
